import { render, staticRenderFns } from "./ElementResultsTooltip.vue?vue&type=template&id=71da6ffa&scoped=true&"
import script from "./ElementResultsTooltip.vue?vue&type=script&lang=ts&"
export * from "./ElementResultsTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./ElementResultsTooltip.vue?vue&type=style&index=0&id=71da6ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71da6ffa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../common/temp/node_modules/.pnpm/vuetify-loader@1.7.3_a266eb3209234f15fc02fe57f54d2cc5/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDivider,VTooltip})
